"use strict";

// This script will need to be added after Coveo loads
window.addEventListener('DOMContentLoaded', function (event) {
  var servicesTopContainer = document.querySelector('.services-search-coveo .landing-top-coveo');
  var searchTrigger = document.querySelector('.landing-top-coveo .CoveoSearchButton');
  var searchResultsContainer = document.querySelector('.landing-top-coveo .coveo-results-column');
  var clearSearchResults = document.querySelector('.landing-top-coveo .clear-results');
  var servicesListing = document.getElementById("servicesListing");
  var servicesListingResults = document.getElementById("servicesListingResults");
  var servicesListPagination = document.getElementById("servicesListPagination");
  var servicesListPageNext = document.getElementById("servicesListingPageNext");
  var servicesListPagePrev = document.getElementById("servicesListingPagePrev");
  var servicesListingTotalResults = document.getElementById("servicesListingTotalResults");
  var servicesListingClearButton = document.getElementById("servicesListingClearButton");
  if (servicesListing) {
    if (servicesTopContainer) {
      searchTrigger.addEventListener('click', function (e) {
        searchResultsContainer.classList.add('active');
      });
      clearSearchResults.addEventListener('click', function (e) {
        searchResultsContainer.classList.remove('active');
      });
    }
    function bindPageSelectPagination() {
      servicesListing.querySelectorAll(".service-results-pagination a.page-select").forEach(function (item) {
        item.addEventListener("click", function () {
          var page = item.getAttribute('data-services-page-num');
          servicesListing.setAttribute("services-data-page", page);
          item.classList.add("active");
          requestServicesListingUpdate();
        });
      });
    }
    function bindClearButton() {
      var clearButton = document.getElementById("servicesListingClearButton");
      clearButton.addEventListener("click", function () {
        servicesListing.setAttribute('services-data-letter', '');
        servicesListing.setAttribute("services-data-page", '1');
        requestServicesListingUpdate();
        clearButton.classList.remove('active');
        servicesListing.querySelectorAll(".services-listing-facet a.letter-select").forEach(function (item) {
          item.classList.remove("active-facet");
        });
      });
    }
    function bindLetterSelectPagination() {
      servicesListing.querySelectorAll(".services-listing-facet a.letter-select").forEach(function (item) {
        item.addEventListener("click", function () {
          servicesListing.querySelectorAll(".services-listing-facet a.letter-select").forEach(function (item) {
            item.classList.remove("active-facet");
          });
          item.classList.add("active-facet");
          var letter = item.getAttribute('services-link-letter');
          servicesListing.setAttribute('services-data-letter', letter);
          servicesListing.setAttribute("services-data-page", '1');
          servicesListingClearButton.classList.add("active");
          requestServicesListingUpdate();
        });
      });
    }
    function bindPaginationArrows() {
      servicesListing.querySelectorAll(".page-previous").forEach(function (item) {
        item.addEventListener("click", function () {
          var page = servicesListing.getAttribute('services-data-page');
          servicesListing.setAttribute("services-data-page", parseInt(page) - 1);
          requestServicesListingUpdate();
        });
      });
      servicesListing.querySelectorAll(".page-next").forEach(function (item) {
        item.addEventListener("click", function () {
          var page = servicesListing.getAttribute('services-data-page');
          servicesListing.setAttribute("services-data-page", parseInt(page) + 1);
          requestServicesListingUpdate();
        });
      });
    }
    function requestServicesListingUpdate() {
      var pageId = servicesListing.getAttribute('services-data-page-id');
      var letter = servicesListing.getAttribute('services-data-letter');
      var page = servicesListing.getAttribute('services-data-page');
      fetch('/api/sitecore/services/services?pageId=' + pageId + '&startLetter=' + letter + '&currentPage=' + page, {
        method: 'get'
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        return updateServicesListing(data);
      }).catch(function (err) {
        //Maybe TODO
      });
    }
    function updateServicesListing(data) {
      updateServicesListingsResults(data);
      updateServicesListingPagination(data);
      updateServicesQueryStringParameters();
    }
    function updateServicesQueryStringParameters() {
      if ('URLSearchParams' in window) {
        var page = servicesListing.getAttribute('services-data-page');
        var letter = servicesListing.getAttribute('services-data-letter');
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set("startLetter", letter);
        searchParams.set("currentPage", page);
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
      }
    }
    function updateServicesListingsResults(data) {
      var html = "";
      data.Items.forEach(function (item) {
        html += '<div class="services-result"><div class="search-component landing"><a href="' + item.Link + '" class="search-content"><h4>' + item.Name + '</h4><p class="summary">' + item.Summary + '</p></a></div></div>';
      });
      servicesListingResults.innerHTML = html;
    }
    function updateServicesListingPagination(data) {
      servicesListPagination.innerHTML = "";
      var page = servicesListing.getAttribute('services-data-page');
      var html = "";
      if (servicesListing.getAttribute("services-data-page") != "1") {
        servicesListPagination.innerHTML = servicesListPagePrev.outerHTML;
      }
      if (data.EndPage > 1) {
        for (var x = data.StartPage; x <= data.EndPage; x++) {
          var activeClass = x == page ? "active" : "";
          html += '<li class="page-item"><a class="page-select ' + activeClass + '" data-services-page-num="' + x + '">' + x + '</a></li>';
        }
      }
      servicesListingTotalResults.innerHTML = data.PaginationText;
      servicesListPagination.innerHTML = servicesListPagination.innerHTML + html;
      if (data.Total > 10 && data.EndPage != servicesListing.getAttribute("services-data-page")) {
        servicesListPagination.innerHTML = servicesListPagination.innerHTML + servicesListPageNext.outerHTML;
      }
      bindPageSelectPagination();
      bindPaginationArrows();
    }
    bindPageSelectPagination();
    bindLetterSelectPagination();
    bindPaginationArrows();
    bindClearButton();
  }
});